import { AfterViewInit } from '@angular/core';
import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { DialogBase, T4Image } from 't4core';
import { CampaignInfo } from '../../../../../projects/t4core/src/public-api';



@Component({
  selector: 'createPartnerCampaignDialog',
  templateUrl: 'createPartnerCampaignDialog.html',
  styleUrls: ['createPartnerCampaignDialog.css'],
})
export class CreatePartnerCampaignDialog extends DialogBase implements AfterViewInit {

  @ViewChild("txtFile") private txtFile: ElementRef;
  @ViewChild('scrollableContainer') scrollableContainer: ElementRef;
  @ViewChild('previewScrollableContainer') previewScrollableContainer: ElementRef;

  campaignForm: FormGroup;

  public campaignInfo: CampaignInfo;
  public listView: boolean = true;
  public slider: number = 25;
  public currentTime: Date = new Date();
  public image: T4Image = new T4Image();
  public editMode: boolean = false;
  public canEdit: boolean = true;
  public discountCode: string = "";
  public placeholderImage: string = "";
  public imageGroup: string = "";
  public loading: boolean = false;
  public hasDiscount: boolean = false;

  public imageDirty: boolean = false;
  private base64ImageData: string = "";

  public offerType: number = 1;

  constructor(
    public dialogRef: MatDialogRef<CreatePartnerCampaignDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignInfo,
    private formBuilder: FormBuilder,
    private renderer: Renderer2
  ) {
    super("createPartnerCampaignDialog");
    if (this.data) {
      this.campaignInfo = this.data;
      this.editMode = true;
    }

    this.canEdit = this.campaignInfo?.CanEdit ?? true;

    this.initializeForm();
  }

  async ngOnInit() {
    this.loading = true
    //If its Edit mod , we get the current image for the the campaign.
    if (this.editMode) {
      this.image = await this.Api.get<T4Image>("Data/GetImage", { type: 6, entityId: this.campaignInfo.DiscountCode });
      this.discountCode = this.campaignInfo.DiscountCode;
    }
    else {
      this.getDiscountCode();
    }
    //Grabbing Logo, is it something we want?
    this.imageGroup = await this.Api.get<string>("Data/GetCurrentGroupImageUri");

    this.loading = false;
  }

  public changeToView(selectedView: boolean) {
    this.listView = selectedView;
  }

  ngAfterViewInit() {
    const dialogElement = this.scrollableContainer.nativeElement.closest('mat-dialog-content');
    if (dialogElement) {
      const dialogHeight = dialogElement.clientHeight;
      const containerHeight = dialogHeight - 20;
      this.renderer.setStyle(this.scrollableContainer.nativeElement, 'height', `${containerHeight}px`);
      this.renderer.setStyle(this.previewScrollableContainer.nativeElement, 'height', `${containerHeight}px`);
    }
  }

  public async save() {
    if (!this.campaignForm.valid) return null;

    this.loading = true;
    const formValues = this.campaignForm.getRawValue();

    this.campaignInfo = {
      ...this.campaignInfo, // Preserve any existing properties not included in the form
      DiscountCode: this.discountCode ?? formValues.DiscountCode,
      ValidFrom: formValues.ValidFrom,
      ValidThrough: formValues.ValidThrough,
      Condition: "true",
      Comment: formValues.Comment,
      CommentIsPublic: true,
      MaxUseCountPerCustomer: 1,
      ConditionText: null,
      Type: 3,
      Value: formValues.Value,
      ValueType: parseInt(formValues.ValueType, 10), // Convert string back to number
      Priority: parseInt(formValues.Priority, 10), // Convert string back to number
      Trigger: parseInt(formValues.Trigger, 10), // Convert string back to number
      Title: formValues.Title,
      IsPartnerDiscount: true,
      CreatedAt: moment().startOf('day'),
      ExternalCode: formValues.ExternalCode,
      PartnerOfferType: formValues.PartnerOfferType,
    };

    switch (formValues.PartnerOfferType)
    {
      case 1:
        //Default, no Change.
        break;
      case 2:
        this.campaignInfo = {
          ...this.campaignInfo,
          PartnerOfferDisclaimer: formValues.Disclaimer,
        }
      case 3:
        this.campaignInfo = {
          ...this.campaignInfo,
          IsTemplate: false,
        }
    }


    if (this.offerType != 3) { //Popup does not use a image.
      //If Image have been touched, we update it.
      if (this.imageDirty)
        await this.Api.post<T4Image>("Data/SetImage", "\"" + this.base64ImageData + "\"", { type: 6, entityId: this.campaignInfo.DiscountCode });
      //If we dont have a image when we create one, we use the placeholder Image.
      else if (!this.editMode && (!this.image.Data || this.image.Data === "") && (!this.image.Uri || this.image.Uri === "")) {
        await this.Api.post<T4Image>("Data/SetDefaultOfferImageImage", null, { entityId: this.campaignInfo.DiscountCode });
      }
    }


    if (this.editMode)
      var ret = await this.Api.post<CampaignInfo>("/Campaign/UpdateCampaign", this.campaignInfo);
    else
      var ret = await this.Api.post<CampaignInfo>("/Campaign/CreateCampaign", this.campaignInfo);

    if (ret) {
      this.loading = false;
      this.dialogRef.close(true);
    }
    else {
      this.loading = false;
      this.UI.snackBarLocal('T4.Campaigns.CampaignDetails.msgerrorcreatecampaign', 'ERROR trying creating campaign')
    }
    this.loading = false;
  }


  public beginUpload() {
    this.txtFile.nativeElement.click();
  }

  public upload(files: FileList) {
    this.imageDirty = true;
    const me = this;
    const file = files[0];

    // Set max file size limit to 3 MB (3 * 1024 * 1024 bytes)
    const maxFileSize = 3 * 1024 * 1024; // 3 MB in bytes

    if (file.size > maxFileSize) {
      alert("The file size exceeds the maximum limit of 3 MB.");
      console.error("File size is too large.");
      return; //How should we handle the error? Error message in front end.
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async function () {
      const image = new Image();
      image.src = reader.result.toString();

      image.onload = function () {
        // Check if the image has a 1:1 aspect ratio
        if (image.width === image.height) {
          me.base64ImageData = reader.result.toString();
          // Strip the base64 prefix if needed
          const formattedBase64ImageData = me.base64ImageData.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
          me.image.Data = formattedBase64ImageData;
        } else {
          // Notify the user that the image is in the wrong format/ratio.
          alert("Please upload an image with a 1:1 aspect ratio.");
        }
      };
    };

    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }


  public async getDiscountCode() {
    this.discountCode = await this.Api.get<string>("/Campaign/GenerateDiscountCode");
  }

  private initializeForm(): void {

    const nonEmpty = Validators.pattern(/\S/);

    this.campaignForm = this.formBuilder.group({
      PartnerOfferType: [{ value: 1, disabled: this.editMode }, Validators.required],
      Title: ["", [Validators.required, nonEmpty, Validators.maxLength(30)]],
      Comment: ["" , [Validators.required, nonEmpty]],
      ExternalCode: ["", [Validators.required, nonEmpty]],
      ValidFrom: ["", [Validators.required]],
      ValidThrough: ["", [Validators.required]],
      ValueType: [""],
      Value: [""],
      Trigger: [1, [Validators.required]],
      Priority: [0],
      PartnerOfferDisclaimer: [""],
    });

    if (this.campaignInfo) {
      this.campaignForm.patchValue({
        ExternalCode: this.campaignInfo.ExternalCode,
        DiscountCode: this.campaignInfo.DiscountCode,
        ValidFrom: this.campaignInfo.ValidFrom,
        ValidThrough: this.campaignInfo.ValidThrough,
        Condition: this.campaignInfo.Condition,
        Comment: this.campaignInfo.Comment,
        CommentIsPublic: this.campaignInfo.CommentIsPublic,
        MaxUseCountPerCustomer: this.campaignInfo.MaxUseCountPerCustomer,
        ConditionText: this.campaignInfo.ConditionText,
        Type: this.campaignInfo.Type,
        Value: this.campaignInfo.Value,
        ValueType: this.campaignInfo.ValueType.toString(), // Handle enum to string conversion
        Priority: this.campaignInfo.Priority.toString(), // Handle number to string conversion
        Trigger: this.campaignInfo.Trigger.toString(), // Handle enum to string conversion
        Title: this.campaignInfo.Title,
        PartnerOfferType: this.campaignInfo.PartnerOfferType,
        PartnerOfferDisclaimer: this.campaignInfo.PartnerOfferDisclaimer,
      });

      this.offerType = this.campaignInfo.PartnerOfferType;
    }




    //Converts the time to hours for easier use for the customers.
    if (this.campaignForm.value.ValueType == 2) {
      const seconds = this.campaignForm.value.Value;
      const hours = seconds / 3600; // Convert seconds to hours
      this.campaignForm.patchValue({ Value: hours }); // Update the Value in the form
    }
  }

  async convertImageToBase64(imagePath: string) {
    fetch(imagePath)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.placeholderImage = reader.result as string;
        };
      })
      .catch(error => console.error("Error fetching image:", error));
  }


  public openInNewTab(raw: string): void {
    const url = this.normalizeUrl(raw);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private normalizeUrl(raw: string): string {
    const s = (raw || '').trim();
    if (!s) return 'about:blank';

    // Already absolute (http:, https:, mailto:, tel:, etc.)
    if (/^[a-z][a-z0-9+.-]*:/.test(s)) return s;

    // Protocol-relative or same-origin absolute path
    if (s.startsWith('//') || s.startsWith('/')) return s;

    return `https://${s}`;
  }


  addEmoji(emoji: string, controlName: string, input: HTMLInputElement | HTMLTextAreaElement): void {
    const control = this.campaignForm.get(controlName); 
    if (!control) return;

    const value = control.value ?? '';

    const start = input.selectionStart ?? value.length;
    const end = input.selectionEnd ?? value.length;

    const nextValue =
      value.slice(0, start) +
      emoji +
      value.slice(end);

    control.setValue(nextValue);
    control.markAsDirty();
    control.markAsTouched();

    setTimeout(() => {
      input.focus();

      const cursor = start + emoji.length;
      input.setSelectionRange(cursor, cursor);
    });
  }

}

